import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  // State
  const notifications = ref([])
  const autoIncrementId = ref(1)

  // Actions
  const showNotification = ({ message, type = 'info', timeout = 4000, persistent = false }) => {
    const notification = {
      id: autoIncrementId.value++,
      message,
      type, // 'success', 'error', 'warning', 'info'
      timeout,
      persistent,
      show: true
    }
    
    notifications.value.push(notification)
    
    // Auto-hide non-persistent notifications
    if (!persistent && timeout > 0) {
      setTimeout(() => {
        hideNotification(notification.id)
      }, timeout)
    }
    
    return notification.id
  }

  const hideNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value[index].show = false
      // Remove from array after animation
      setTimeout(() => {
        const currentIndex = notifications.value.findIndex(n => n.id === id)
        if (currentIndex > -1) {
          notifications.value.splice(currentIndex, 1)
        }
      }, 300)
    }
  }

  const clearAll = () => {
    notifications.value = []
  }

  // Convenience methods
  const showSuccess = (message, options = {}) => {
    return showNotification({ message, type: 'success', ...options })
  }

  const showError = (message, options = {}) => {
    return showNotification({ message, type: 'error', ...options })
  }

  const showWarning = (message, options = {}) => {
    return showNotification({ message, type: 'warning', ...options })
  }

  const showInfo = (message, options = {}) => {
    return showNotification({ message, type: 'info', ...options })
  }

  return {
    // State
    notifications,
    
    // Actions
    showNotification,
    hideNotification,
    clearAll,
    
    // Convenience methods
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
})



